import React from "react";
import "./immobilienvermittlungRightContent.scss";
import ThreeImage from "../../../../assets/images/three-image.png";
import FiveImage from "../../../../assets/images/five-image.png";
import SixImage from "../../../../assets/images/six-image.png";
import { NavLink } from "react-router-dom";
export default function ImmobilienvermittlungRightContent() {
  return (
    <div>
      <div className="immobilienvermittlung-right-content-alignment">
        <div className="box-alignment">
          <div className="grid">
            <div className="grid-items">
              <div className="image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__backInUp animate__animated wow"
                    data-wow-offset="100"
                    src={ThreeImage}
                    alt="ThreeImage"
                  />
                </NavLink>
              </div>
            </div>
            <div className="grid-items">
              <div className="fix-box-width">
                <p
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Nutzen Sie das bundesweite Netzwerk der Deutscher Immobilien
                  Dienst GmbH.
                </p>
                <ul>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Wir haben Profis vor Ort, die sich auskennen.
                  </li>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Wir haben zahlreiche Interessenten, dessen Bonität von uns
                    bereits geprüft wurde.
                  </li>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Wir ermitteln den marktgerechten Preis aufgrund von Lage,
                    Objektart, Ausstattung und weiteren Merkmalen individuell.
                  </li>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Wir erstellen Ihr Exposé mit Fotos, aussagekräftigen Texten
                    und genauen Angaben zur Größe und Beschaffenheit. Bei Bedarf
                    helfen wir Ihnen zum Energieausweis.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="immobilienvermittlung-all-right-content-alignment">
        <div className="box-style">
          <div className="grid">
            <div className="grid-items">
              <div className="fix-width">
                <ul>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Wir führen die Besichtigungen durch. Sie müssen nicht
                    alleine "Fremden" die Tür öffnen.
                  </li>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Wir sind für Sie da! Mit Rat und Tat stehen wir bis zum
                    Vertragsabschluss und Übergabe an Ihrer Seite.
                  </li>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Durch die schnellen Finanzierungszusagen unseres Partners
                    ING-DiBa ist ein reibungsloser Ablauf gesichert.
                  </li>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Allen Beteiligten ist unsere Diskretion garantiert.
                  </li>
                  <li
                    className="animate__fadeInUp animate__animated wow"
                    data-wow-offset="100"
                  >
                    Bei erfolgreichem Geschäftsabschluss erhalten wir, wie
                    vereinbart, unser Honorar von unserem Interessenten.
                  </li>
                </ul>
              </div>
            </div>
            <div className="grid-items">
              <div className="five-image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__backInUp animate__animated wow"
                    data-wow-offset="100"
                    src={FiveImage}
                    alt="five-image"
                  />
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wir-suchen-right-all-content-alignment">
        <div className="new-box-style">
          <div className="grid">
            <div className="grid-items">
              <div className="six-image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__backInUp animate__animated wow"
                    data-wow-offset="100"
                    src={SixImage}
                    alt="SixImage"
                  />
                </NavLink>
              </div>
            </div>
            <div className="grid-items">
              <p>Wir suchen für Sie Immobilien im gesamten Bundesgebiet</p>
              <ul>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Grundstücke
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Eigentumswohnungen
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Reihenhäuser
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Doppelhaushälften
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  freistehende Einfamilienhäuser
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Mehrfamilienhäuser
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Wohn-/Geschäftshäuser
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Renditeobjekte
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Gewerbeobjekte
                </li>
                <li
                  className="animate__fadeInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Immobilienportfolios
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
